import { ReactNode } from 'react';

import classNames from 'classnames';

interface RadioButtonProps {
  isSelected: boolean;
  hasError?: boolean;
  onToggle?: (isSelected: boolean) => void;
}

const RadioButton = ({ isSelected, hasError, onToggle }: RadioButtonProps) => {
  return (
    <div
      className={classNames('radio-button', {
        'has-error': hasError,
        selected: isSelected,
      })}
      onClick={() => onToggle && onToggle(isSelected)}
    >
      <div className='radio-button__bullet' />
    </div>
  );
};

interface RadioButtonCellProps extends RadioButtonProps {
  className?: string;
  children: ReactNode;
}

export const RadioButtonCell = ({
  className,
  children,
  isSelected,
  onToggle,
  ...radioButtonProps
}: RadioButtonCellProps) => {
  return (
    <div
      className={classNames('radio-button__wrapper', className)}
      onClick={() => onToggle && onToggle(!isSelected)}
    >
      <RadioButton isSelected={isSelected} {...radioButtonProps} />
      {children}
    </div>
  );
};

export default RadioButton;
